import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  label: {
    '& p': {
      alignSelf: 'baseline',
      lineHeight: 2,
      fontSize: 14,
    },
  },
  warningText: {
    color: theme.palette.gray.efesGray,
  },
  valueContainer: {
    alignSelf: 'center',
    fontSize: 14,
    textAlign: 'right',
  },
  icon: {
    marginRight: '.5rem',
    paddingTop: '0.3rem',
  },
  activeElitePlan: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  includedInsuranceSection: {
    padding: '0.625rem 0 0.625rem',
  },
  centeredDiv: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}));

export default useStyles;
